import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=b0c404ea&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"
import style0 from "./Share.vue?vue&type=style&index=0&id=b0c404ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c404ea",
  null
  
)

export default component.exports